import { NIVEIS_DE_APLICACAO, type NivelDeAplicacao } from '../../types/nivelDeAplicacao';

/**
 * O destino que a URL mandou abrir: a empresa da pendência do documento
 * (`/risk-applications?companyId=7`) ou a unidade escolhida na lista de Unidades
 * (`?nivel=unit&companyId=7&unitId=12`, #541).
 *
 * Sem ler os parâmetros, quem chega por um desses links cai numa tela em branco e precisa
 * adivinhar de qual empresa ou unidade vinha o pedido.
 *
 * Mora fora da página porque quem exporta função ao lado de um componente quebra o
 * fast-refresh do Vite (`react-refresh/only-export-components`).
 */
export interface DestinoDaBusca {
  nivel: NivelDeAplicacao | null;
  companyId: number | null;
  unitId: number | null;
}

export function destinoDaBusca(busca: string): DestinoDaBusca {
  const parametros = new URLSearchParams(busca);
  return {
    nivel: nivelValido(parametros.get('nivel')),
    companyId: idValido(parametros.get('companyId')),
    unitId: idValido(parametros.get('unitId')),
  };
}

export function empresaDaBusca(busca: string): number | null {
  return destinoDaBusca(busca).companyId;
}

function idValido(texto: string | null): number | null {
  const valor = Number(texto);
  return Number.isInteger(valor) && valor > 0 ? valor : null;
}

function nivelValido(texto: string | null): NivelDeAplicacao | null {
  return NIVEIS_DE_APLICACAO.find((nivel) => nivel === texto) ?? null;
}
